// @flow @jsx h
import { Component, h } from 'preact'
import { SmartVideo, ViewportIntersections } from '@nrk/dh-feature-components'
import { bem } from '@nrk/dh-utils'
import { Header } from './Header'
import { Logo } from './Logo'
import { toVideoSrc } from '../../common'

/* styles */
import styles from './index.css'
import '@nrk/dh-feature-components/dist/module/video/SmartVideo/index.css'

/* types */
import type { IntroVideo } from '../domain'

type Props = {
  introVideo: IntroVideo,
  fornavn: string,
  etternavn: string,
  stikktittel: string,
  byline: string,
  bylinebilde: string,
  viewport: { height: number }
}

type State = {
  activeIdx: number,
  logoAllowed: boolean,
  logoComplete: boolean,
  portraitVisible: boolean,
  playing: boolean
}

export class Intro extends Component<Props, State> {
  timeout: any
  texts: HTMLElement[] = []

  constructor () {
    super()
    this.state = {
      playing: false,
      logoAllowed: false,
      logoComplete: false,
      portraitVisible: false
    }
  }

  handleChange = (intersections: any[]) => {
    const activeIntersection = intersections
      .map((intersection, idx) => ({ ...intersection, idx }))
      .filter(intersection => intersection.isIntersecting)
      .sort((a, b) => b.ratio - a.ratio)
      .shift()

    let nextState = {}
    if (!activeIntersection) {
      nextState = { activeIdx: -1, playing: false }
    } else {
      const idx = activeIntersection.idx
      if (idx === 0) {
        nextState = { activeIdx: 0, portraitVisible: false, playing: true, logoAllowed: true }
      } else {
        nextState = { activeIdx: -1, portraitVisible: true, playing: false, logoAllowed: false, logoComplete: true }
      }
    }

    this.setState(nextState)
  }

  setLogoComplete = () => {
    if (!this.state.logoComplete) {
      this.setState({ logoComplete: true })
    }
  }

  render () {
    const { fornavn, etternavn, stikktittel, viewport, introVideo } = this.props
    const { playing, logoAllowed, logoComplete, portraitVisible } = this.state
    const rootMargin = `-50% 0px 0px 0px`

    return (
      <div class={styles.intro}>
        <div class={bem(styles.intro__content, { portraitVisible, logoComplete })}>
          <div class={bem(styles.intro__mediaContainer, { portraitVisible })}>
            {introVideo && <SmartVideo
              preload='none'
              muted
              playsInline
              playing={playing}
              className={styles.intro__smartVideo}
              resolution720p={toVideoSrc(introVideo.horizontal['720'])}
              resolution960p={toVideoSrc(introVideo.vertical['960'])}
              resolution1080p={toVideoSrc(introVideo.horizontal['1080'])}
              viewport={viewport}
            />
            }

          </div>
          <Logo
            allowed={logoAllowed}
            complete={logoComplete}
            onComplete={this.setLogoComplete}
            viewport={viewport} />
          <ViewportIntersections
            className={styles.intro__blocks}
            rootMargin={rootMargin}
            threshold={[0, 0.1, 0.5, 0.9, 1]}
            onChange={this.handleChange}>
            {
            }
            <Header fornavn={fornavn} etternavn={etternavn} stikktittel={stikktittel} />
          </ViewportIntersections>
        </div>
      </div>
    )
  }
}
